// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const sseClient = createTypedClient();
export const createSseClient = (config) => createTypedClient(config);
